import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/lego';

export const groups: ThemedFunctor = ({
  theme,
}) => css`
  column-count: 2;
  column-gap: ${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    column-count: 4;
    column-gap: ${theme.spaceUnits.desktop.SMALL};
  }
`;

export const group: ThemedFunctor = ({
  theme,
}) => css`
  clear: both;
  word-wrap: break-word;
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  break-inside: avoid;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALLER)}
  color: ${theme.palettes.neutrals.darkest};
  margin: 0;
  font-weight: bold;

  a {
    text-decoration: none;
  }
`;

export const link: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALLER)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.neutrals.darkest};
  text-decoration: none;
  display: block;
`;
